import { Fragment } from "react";
import "./user_exercise_test.scss";

import LoaderPopUp from "../../../components/loader/loader";

///////////////////Desktop
import LeftSideBarComponent from "../structure_components/desktop_screens/left_sideBar_component/left_sideBar_component";
import HeaderComponent from "../structure_components/desktop_screens/header_component/header_component";

///////Mobile////////////////////
import MobileLeftSideBarComponent from "../structure_components/mobile_screens/mobile_left_sideBar_component/mobile_left_sideBar_component";
import MobileHeaderComponent from "../structure_components/mobile_screens/mobile_header_component/mobile_header_component";
import MobileRightSideBarComponent from "../structure_components/mobile_screens/mobile_right_sideBar_component/mobile__right_sideBar_component";

import UserExerciseTestContentComponent from "./user_exercise_test_content_component/user_exercise_test_content_component";

//Redux
import { connect } from "react-redux";

const UserExerciseTest = (props) => {
  let { history, loader, userData, userPreference } = props;

  const isMob = () => {
    if (window.innerWidth <= 480) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Fragment>
      <div className="user_exercise_test_wrapper">
        <div className="user_exercise_test_inner_wrapper">
          {isMob() ? (
            /////for Mobile Screens////////////////////
            <Fragment>
              <UserExerciseTestContentComponent
                history={history}
                userData={userData}
                userPreference={userPreference}
              />
            </Fragment>
          ) : (
            /////for Screens greater than Mobile Screens////////////////////
            <Fragment>
              <div className="user_exercise_test_right_wrapper">
                <UserExerciseTestContentComponent
                  history={history}
                  userData={userData}
                  userPreference={userPreference}
                />
              </div>
            </Fragment>
          )}
        </div>
      </div>
      {loader && <LoaderPopUp />}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps)(UserExerciseTest);
